import type React from "react"
import type { TagResponse } from "@/types/domain"
import "./TagFilter.css"

type TagFilterProps = {
  tagGroups: Record<string, { title: string; tags: TagResponse[] }>
  activeGroup: string | null
  onGroupClick: (groupName: string) => void
}

export const TagFilter: React.FC<TagFilterProps> = ({
  tagGroups,
  activeGroup,
  onGroupClick,
}) => {
  return (
    <div className="tag-filter-container">
      <div className="tag-groups">
        {Object.entries(tagGroups).map(([groupName, groupData]) => (
          <button
            key={groupName}
            className={`tag-group-button ${
              activeGroup === groupName ? "active" : ""
            }`}
            onClick={() => { onGroupClick(groupName); }}
          >
            {groupData.title}
          </button>
        ))}
      </div>
    </div>
  )
}
